import React from 'react';
import {useSelector} from "react-redux";
import {Fab} from '@material-ui/core';
import UndoIcon from '@material-ui/icons/Undo';
import {FormikHelpers} from "formik";
import * as yup from 'yup';
import {RootState} from "../../reducers";
import {useActions} from "../../actions";
import * as ClientActions from "../../actions/client";
import {RequestChangesForm} from "./index";
import GenericDialog from "../../components/dialog/GenericDialog";
import {FormikValues, FormikWrapper} from "../../components/formikFormInputs";
import {REQUIRED_FIELD} from "../../constants";


const RCButton = () => {
    const clientsAction = useActions(ClientActions);
    const [showForm, setShowForm] = React.useState(false);
    const {user} = useSelector((store: RootState) => store.auth);
    const clientPolicyId = user && user.client && user.client.clientPolicies && user.client.clientPolicies[0] && user.client.clientPolicies[0].id;

    const toggleShowForm = () => setShowForm(!showForm);
    const onSubmit = async (values: FormikValues, {resetForm}: FormikHelpers<any>) => {
        await clientsAction.requestEstimatorChanges({...values, clientPolicyId});
        resetForm();
        setShowForm(false);
    };
    const validationSchema = yup.object({
        message: yup.string().required(REQUIRED_FIELD).max(500, 'Must be within 500 characters')
    });

    return (
            <div className="mt10 floatLeft">
                {
                        !showForm &&
                        <Fab aria-label="request changes" color="primary" onClick={toggleShowForm} variant="extended">
                            <UndoIcon className="mr15" />
                            Request Changes
                        </Fab>
                }

                <GenericDialog
                        aria-describedby="request-estiator-changes"
                        content={
                            (
                                    <FormikWrapper
                                            children={RequestChangesForm}
                                            initialValues={{message: ''}}
                                            onSubmit={onSubmit}
                                            validationSchema={validationSchema}
                                    />
                            )
                        }
                        fullWidth
                        keepMounted
                        maxWidth="sm"
                        onClose={toggleShowForm}
                        open={showForm}
                        title="Request Estimator Changes from Agent"
                />
            </div>
    );
};

export default RCButton;
